<template>
  <div v-if="hasVisibleContent" class="px-5 h-full w-full mt-2">
    <div class="py-2 max-w-xl mx-auto w-full">
      <div
        class="flex min-w-0 w-full px-6"
        :class="compact ? 'flex-col gap-3' : 'flex-col md:flex-row gap-3 md:gap-4 md:items-center'"
      >
        <div v-if="!compact" class="hidden md:block flex-shrink-0 text-sm text-gray-brand-700">
          <template v-if="nextPricingTier">
            <span class="font-semibold text-brand-600">{{ progressText }}</span>
            for {{ nextPricingTier.attributes.title }}
          </template>
          <template v-else-if="pricingTier && !pricingTier.attributes.is_default">
            You've unlocked {{ pricingTier.attributes.title }}!
          </template>
        </div>

        <div class="flex-1 min-w-0 pr-4" :class="{ 'md:pr-6': !compact }">
          <div class="relative h-2.5 bg-gray-brand-200 overflow-hidden rounded-full">
            <div
              class="absolute inset-y-0 left-0 rounded-full transition-all duration-1000 ease-out"
              :style="{ width: fillWidth, background: gradientStyle }"
            />
          </div>
        </div>

        <slot />
      </div>

      <div class="text-sm text-gray-brand-700 px-6 mt-3" :class="compact ? 'text-left' : 'text-center md:hidden'">
        <template v-if="nextPricingTier">
          <span class="font-semibold text-brand-600">{{ progressText }}</span>
          for {{ nextPricingTier.attributes.title }}
        </template>
        <template v-else-if="pricingTier && !pricingTier.attributes.is_default">
          You've unlocked {{ pricingTier.attributes.title }}!
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PricingTierProgressBarSimple',
  props: {
    compact: { type: Boolean, default: false }
  },
  computed: {
    cart() {
      return this.$store.getters.currentCart
    },
    pricingTierID() {
      return this.cart?.relationships?.pricing_tier?.data?.id
    },
    pricingTier() {
      return this.$store.getters.pricingTierWithID(this.pricingTierID)
    },
    nextPricingTierID() {
      return this.cart?.relationships?.next_pricing_tier?.data?.id
    },
    nextPricingTier() {
      return this.$store.getters.pricingTierWithID(this.nextPricingTierID)
    },
    progressText() {
      return this.cart?.attributes?.progress_remaining_language_next_pricing_tier
    },
    fillWidth() {
      const pct = this.cart?.attributes?.progress_toward_next_pricing_tier || 0
      return `${pct}%`
    },
    hasVisibleContent() {
      if (this.nextPricingTier) return true
      return !!(this.pricingTier && !this.pricingTier.attributes.is_default)
    },
    gradientStyle() {
      return 'linear-gradient(to right, hsl(var(--main-brand-hue), var(--main-brand-saturation-200), var(--main-brand-lightness-200)), hsl(var(--main-brand-hue), var(--main-brand-saturation-500), var(--main-brand-lightness-500)))'
    }
  }
}
</script>
